<p>Select a role to login to below</p>
<button id="none" (click)="fakeNone()">No Group</button><br/>
<button id="generalUser" (click)="fakeGeneral()">General User</button><br/>
<button id="manager" (click)="fakeManager()">Assessment Manager</button><br/>
<button id="admin" (click)="fakeAdmin()">System Admin</button><br/><br/><br/>
<button id="admin" (click)="signOut()">Sign Out</button>